<template>
  <div ref="wrapper" id="appWrapper" class="app-wrapper" :class="center ? 'wrapper-center' : ''">
    <!-- <keep-alive> -->
      <router-view @textBlur="textBlur"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'layout',
  data () {
    return {
      transitionName: 'slide-left',
      routerList: ['/collection/ask',
  '/collection/detail',
  '/collection/modal',
  '/collection/user',
  '/collection/score',],
      center: false,
      // isPanelShow: false
    }
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      this.center = this.routerList.indexOf(to.path) > -1;
      // 处理ios端微信浏览器前进返回占位问题
      if (to.path === '/collection/user') {
        setTimeout(() => {
          this.$refs.wrapper.scrollTop = this.$refs.wrapper.scrollHeight
        },50)
      } else {
        setTimeout(() => {
          this.$refs.wrapper.scrollTop = 0
        },50)
      }
    }
  },
  created () {
    this.center = this.routerList.indexOf(this.$route.path) > -1;
    // 处理ios端微信浏览器前进返回占位问题
    if (this.$route.path === '/collection/user' || this.$route.path === '/clue/index') {
      setTimeout(() => {
        this.$refs.wrapper.scrollTop = this.$refs.wrapper.scrollHeight
      },50)
    } else {
      setTimeout(() => {
        this.$refs.wrapper.scrollTop = 0
      },50)
    }
  },
  methods: {
    // closeShadow () {
    //   this.isPanelShow = false
    // }

    textBlur() {
      setTimeout(() => {
        this.$refs.wrapper.scrollTop = 0
      }, 10)
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    -webkit-tap-highlight-color: transparent;
  }
  .app-wrapper {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    /* 禁用iOS橡皮筋效果 - 这个是必要的 */
    overscroll-behavior: none;
    overscroll-behavior-y: none;
    -webkit-overscroll-behavior: none;
  }
  .wrapper-center {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue